/**
 * Created by Christof Sander on 16.06.2016.
 */

const CONSTANTS = require('../../lib/constants');
const utils     = require('../../lib/utils');

module.exports = {
	config: {
		selectActualNodeAfterRefresh: true,
		selectNewNodeAfterRefresh: true,
		searchDelay: 200,
		supportOnScrollLimits: false,
		readyNodeID: undefined,
		readyNodeContext: '',
		refreshStrategy: 'sanitize',
		reloadDataOnFilterReset: true,
		nodeActionMapping: {
			defaultOperation: {
				select: 'showEdit',
				deselect: 'showEdit'
			}
		},
		treeIndexMapping: {},
		defaultTreeOperationsOnFirstTree: true,
		focusAble: true,
		focusPriority: 0,
		treeTypeComponents: {
			default: [
				'/',
				'base',
				'trees',
				'tree'
			]
		},
		maxOpenedLevelOnInit: 0,
		preventGUIHandlingOfMaxOpenedLevelOnInit: false
	},

	model: {
		filterParams: {},
		actualNrOfTrees: 0,
		states: {
			activeTreeComponentIndex: undefined,
			autoSelect: false,
			trees: {}
		},
		specialNodeData: {}
		// filters: {
		// 	fullTextSearch: true,
		// 	languages: [
		// 		{
		// 			title: 'German',
		// 			icon: ''
		// 		},
		// 		{
		// 			title: 'English',
		// 			icon: ''
		// 		}
		// 	]
		// },
		// trees: [
		// 	{
		// 		name: 'DUMMY TREE',
		// 		tree: []
		// 	}
		// ]
	},

	actions: {
		addTree: {
			type: CONSTANTS.COMPONENT.ACTION.TYPE.LOAD,
			source: {},
			target: {
				element: CONSTANTS.COMPONENT.ACTION.TARGET.ELEMENT.SELF,
				position: CONSTANTS.COMPONENT.ACTION.TARGET.POSITION.APPEND
			}
		}
	},

	methods: {

		/**
		 * this function is used to be performed after the attach hook has been done.
		 * NOTE: this function can be used by components which extend this component.
		 *
		 * @params bool refreshResourcesOnly - default: false - depends on attachTriggerOption "refreshResourcesOnly"
		 */
		onAttachDone: function(refreshResourcesOnly = false){},

		/**
		 * this function returns if the trees are ready or not.
		 * NOTE:    if there are no trees this function returns true.
		 * NOTE:    functions registered via onTreesReadyCallback will called one after the other. (immediatly or onReady-event).
		 *
		 * @param   onTreesReadyCallback        function - callback which should be called immediately if all trees are ready or when they are ready.
		 * @returns {boolean}
		 */
		treesReady: function(onTreesReadyCallback){
			var ready = this.config.isReady;
			if(ready){
				utils.forEach(this.model.states.trees, function(states, treeComponentIndex){
					ready = ready && getComponent(treeComponentIndex).isReady();
				});
			}

			// if necessary the callback function will be called by this.treesReadyCallback
			if(utils.isFunction(onTreesReadyCallback)) {
				if(!this._onTreesReadyCallbacks) this._onTreesReadyCallbacks = [];
				this._onTreesReadyCallbacks.push(onTreesReadyCallback);
			}

			if((this._onTreesReadyCallbacks || []).length > 0){
				if(!ready){
					this.$.removeClass('treesReady');
				}
				else if(!this.$.hasClass('treesReady')){
					this.$.addClass('treesReady');
					for(var c in this._onTreesReadyCallbacks){
						this._onTreesReadyCallbacks[c]();
					}
					this._onTreesReadyCallbacks = [];
				}
			}
			return ready;
		},

		/**
		 * this function is used to get a unique and bidirectional translatable identifier according to the given parameters.
		 *
		 * @param   nodeID      	mixed - real nodeID
		 * @param   context     	string - node context (e.g., component, atom, section, ...)
		 * @param   treeIndex   	number - index of actual tree
		 * @param   nodeTreeIndex   number - incrementing counter for nodes per trees object.
		 * @returns int - tree node index (id)
		 */
		transformIDToIndex: function(nodeID, context, treeIndex, nodeTreeIndex){
			if(!context) context = '';
			var key = this.getNodeIndex(nodeID, context, true);
			this.config.treeIndexMapping[key] = {
				treeIndex: treeIndex,
				nodeTreeIndex: nodeTreeIndex,
				nodeID: nodeID,
				context: context,
				key: key
			};
			return key;
		},

		/**
		 * this function returns the tree node index (id) according to the given parameters.
		 *
		 * @param   nodeID      			mixed - real nodeID
		 * @param   context     			string - node context (e.g., component, atom, section, ...)
		 * @param   preventMappingCheck		boolean - default: false - prevent check if mapping exists
		 * @returns int - tree node index (id)
		 */
		getNodeIndex: function(nodeID, context, preventMappingCheck = false){
			if(!context) context = '';
			if(!nodeID){
				console.log('missingNodeID', nodeID, context);
			}
			if(nodeID && (nodeID != (nodeID * 1))){
				nodeID = utils.md5(nodeID);
			}
			var key = context + '-' + nodeID;
			if(preventMappingCheck || this.config.treeIndexMapping[key]) return key;
			return;
		},

		/**
		 * this function returns if a tree node exists according to the given parameters.
		 *
		 * @param   nodeID      mixed - real nodeID
		 * @param   context     string - node context (e.g., component, atom, section, ...)
		 * @returns boolean
		 */
		nodeExists: function(nodeID, context){
			return this.getNodeIndex(nodeID, context) !== undefined;
		},

		/**
		 * return true if the given nodeIndex does exist and false otherwise.
		 *
		 * @param   nodeIndex       int - nodeIndex
		 * @returns {boolean}
		 */
		nodeExistsByIndex: function(nodeIndex){
			return this.config.treeIndexMapping[nodeIndex] !== undefined;
		},

		/**
		 * this function returns the original node id according to the given tree node index.
		 *
		 * @param   nodeIndex       int - nodeIndex
		 * @returns mixed - original nodeID or -1 if nodeIndex could not be found
		 */
		getNodeID: function(nodeIndex){
			if(this.config.treeIndexMapping[nodeIndex]){
				return this.config.treeIndexMapping[nodeIndex].nodeID;
			}
			return -1;
		},

		/**
		 * this function returns the node context according to the given tree node index.
		 *
		 * @param   nodeIndex       int - nodeIndex
		 * @returns string - node context
		 */
		getNodeContext: function(nodeIndex){
			if(nodeIndex && this.config.treeIndexMapping[nodeIndex]) return this.config.treeIndexMapping[nodeIndex].context;
			return '';
		},

		/**
		 * this function is used to reset the nodeID to index mapping.
		 * NOTE: the first position within this array will be preset in order to prevent if(id)-problems caused by zero.
		 */
		resetNodeMappings: function(){
			this.config.treeIndexMapping = {};
		},

		/**
		 * this function returns the nodeIndex of the element which is selected within the actual active tree.
		 *
		 * @returns int - nodeIndex (-1 in an error case)
		 */
		getSelectedNodeIndex: function(){
			if(!this.model.states.activeTreeComponentIndex || ! this.model.states.trees[this.model.states.activeTreeComponentIndex]) return;
			return this.model.states.trees[this.model.states.activeTreeComponentIndex].selectedNodeIndex;
		},

		/**
		 * this function returns the nodeIndex of the element which has the same type
		 * as the node identified by the given nodeIndex or the given nodeContext parameter and
		 * is located before the actual element.
		 *
		 * @param   nodeIndex       int - nodeIndex (default: actual selected node index)
		 * @param   nodeContext     string - nodeContext
		 * @returns int - nodeIndex or undefined if there is no previous node
		 */
		getNodeIndexBefore: function(nodeIndex, nodeContext){
			nodeIndex = nodeIndex || this.getSelectedNodeIndex();
			nodeContext = nodeContext || this.getNodeContext(nodeIndex);
			var treeStart = 0;
			for(var t = 0; t < this.model.actualNrOfTrees; t++){
				if(this.registry[t] && this.registry[t].tree && this.registry[t].tree.config){
					treeStart = this.registry[t].tree.config.minIndex;
				}
			}

			var indexes = Object.keys(this.config.treeIndexMapping);
			var realIndex = utils.indexOf(indexes, nodeIndex);
			for(var i = realIndex - 1; i >= treeStart; i--){
				if(nodeContext === this.getNodeContext(indexes[i])){
					return indexes[i];
				}
			}

			return undefined;
		},

		/**
		 * this function returns the nodeIndex of the element which has the same type
		 * as the node identified by the given nodeIndex or the given nodeContext parameter and
		 * is located after the actual element.
		 *
		 * @param   nodeIndex       int - nodeIndex (default: actual selected node index)
		 * @param   nodeContext     string - nodeContext (default: context of given nodeIndex)
		 * @returns int - nodeIndex or undefined if there is no previous node
		 */
		getNodeIndexAfter: function(nodeIndex, nodeContext){
			nodeIndex = nodeIndex || this.getSelectedNodeIndex();
			nodeContext = nodeContext || this.getNodeContext(nodeIndex);
			var treeEnd = 0;
			for(var t = 0; t < this.model.actualNrOfTrees; t++){
				if(this.registry[t] && this.registry[t].tree && this.registry[t].tree.config){
					treeEnd = this.registry[t].tree.config.maxIndex;
				}
			}

			var indexes = Object.keys(this.config.treeIndexMapping);
			var realIndex = utils.indexOf(indexes, nodeIndex);
			for(var i = realIndex + 1; i <= treeEnd; i++){
				if(nodeContext === this.getNodeContext(indexes[i])){
					return indexes[i];
				}
			}

			return undefined;
		},

		/**
		 * this function returns parent node index of the node identified by the actualNodeIndex param.
		 * NOTE: if the parent cannot be found this function throws an error.
		 * NOTE: this function will work only if the iterative jstree format will be used (parent flag not children flag)
		 *
		 * @param   actualNodeIndex     int - which node's parent node index should be returned
		 * @returns number - parent node index
		 */
		getParentNodeIndex: function(actualNodeIndex){
			if(!this.resourceData || utils.isEmpty(this.resourceData.trees)) return false;

			if(utils.isEmpty(actualNodeIndex)) throw new Error('cannot find parent node index of empty actualNodeIndex');

			var actualEntry;
			var entry;
			actualEntry = this.config.treeIndexMapping[actualNodeIndex];
			if(actualEntry && actualEntry.treeIndex != undefined && actualEntry.nodeTreeIndex != undefined && this.resourceData.trees[actualEntry.treeIndex] && this.resourceData.trees[actualEntry.treeIndex].tree){
				entry = this.resourceData.trees[actualEntry.treeIndex].tree[actualEntry.nodeTreeIndex];
				if(entry){
					if(!utils.isEmpty(entry.parent) && entry.parent !== '#'){
						return entry.parent;
					}
				}
				else {
					throw new Error('parent index not found in entry');
				}
			}
			else {
				throw new Error('parent Index not found');
			}

			throw new Error('parent Index not found in tree');
		},

		/**
		 * this function returns the original nodeID of the element which is selected within the actual active tree.
		 *
		 * @returns mixed - original nodeID
		 */
		getSelectedNodeID: function(){
			return this.getNodeID(this.model.states.trees[this.model.states.activeTreeComponentIndex].selectedNodeIndex);
		},

		/**
		 * this function returns the treeComponentIndex of the given nodeIndex.
		 *
		 * @param   nodeIndex       int - nodeIndex
		 * @returns mixed           int || false - treeComponentIndex or false in an error case.
		 */
		getNodeTreeComponentIndex: function(nodeIndex){
			if(
				nodeIndex &&
				this.config.treeIndexMapping &&
				this.config.treeIndexMapping[nodeIndex] &&
				this.config.treeIndexMapping[nodeIndex].treeIndex != undefined &&
				this.registry[this.config.treeIndexMapping[nodeIndex].treeIndex] &&
				this.registry[this.config.treeIndexMapping[nodeIndex].treeIndex].tree &&
				this.registry[this.config.treeIndexMapping[nodeIndex].treeIndex].tree.componentIndex
			){
				return this.registry[this.config.treeIndexMapping[nodeIndex].treeIndex].tree.componentIndex;
			}

			return false;
		},

		/**
		 * this function returns the node (tree) data identified by the given nodeIndex.
		 *
		 * @param   nodeIndex               int - nodeIndex
		 * @param   treeComponentIndex      int - treeComponentIndex - optional (if not given the activeTreeComponentIndex will be used)
		 * @returns {} - data which has been constructed for the tree handler
		 *               returns {} in an error case
		 */
		getNode: function(nodeIndex, treeComponentIndex){
			if(!treeComponentIndex) treeComponentIndex = this.model.states.activeTreeComponentIndex;
			var component;
			if(treeComponentIndex && (component = getComponent(treeComponentIndex))) return component.getNode(nodeIndex);
		},

		/**
		 * this function returns the original nodeData identified by the given nodeIndex.
		 *
		 * @param   nodeIndex               int - nodeIndex
		 * @param   treeComponentIndex      int - treeComponentIndex - optional (if not given the activeTreeComponentIndex will be used)
		 * @returns {} - data which has been deposited for a tree node which cannot be deposited within the normal tree structure.
		 *               returns {} in an error case
		 */
		getNodeData: function(nodeIndex, treeComponentIndex){
			if(!treeComponentIndex) treeComponentIndex = this.model.states.activeTreeComponentIndex;
			var component;
			if(treeComponentIndex && (component = getComponent(treeComponentIndex))) return component.getNodeData(nodeIndex);
			return {};
		},

		/**
		 * this function returns the original nodeData identified by the given nodeIndex and all of its childrens' nodeData.
		 *
		 * @param   nodeIndex               int - nodeIndex
		 * @param   treeComponentIndex      int - treeComponentIndex - optional (if not given the activeTreeComponentIndex will be used)
		 * @param   includeParent			boolean - should the nodeData of the given nodeIndex be included or not.
		 * @returns {} - data which has been deposited for a tree node which cannot be deposited within the normal tree structure.
		 *               returns {} in an error case
		 */
		getNodeChildrenData: function(nodeIndex, treeComponentIndex, includeParent){
			if(!treeComponentIndex) treeComponentIndex = this.model.states.activeTreeComponentIndex;
			var component;
			if(treeComponentIndex && (component = getComponent(treeComponentIndex))) return component.getNodeChildrenData(nodeIndex, includeParent);
			return {};
		},

		/**
		 * this function is used to return the actual selected nodes' data.
		 *
		 * @returns {} - nodeData or {} if no node is selected
		 */
		getSelectedNodeData: function(){
			var nodeIndex = this.getSelectedNodeIndex();
			if(nodeIndex !== undefined){
				return this.getNodeData(nodeIndex);
			}
			return {};
		},

		/**
		 * this function stores specialNodeData by key.
		 *
		 * @param key 	string - special node identifier
		 * @param nodeData 	{} - moving node data
		 */
		setSpecialNodeData: function(key, nodeData){
			this.model.specialNodeData[key] = nodeData;
		},

		/**
		 * this function returns specialNodeData by key.
		 *
		 * @param key 	string - special node identifier
		 * @returns		{} - special node data
		 */
		getSpecialNodeData: function(key){
			if(key) return this.model.specialNodeData[key];
			return this.model.specialNodeData;
		},

		/**
		 * return all nodes' indexes or data which are checked.
		 * NOTE: this feature is only available if the corresponding tree uses the checkbox plugin.
		 *
		 * @param   fullDataSet     boolean - should the full data be returned or just the indexes
		 * @returns []
		 */
		getCheckedNodes: function(fullDataSet, treeComponentIndex){
			if(!treeComponentIndex) treeComponentIndex = this.model.states.activeTreeComponentIndex;
			var component;
			if(treeComponentIndex && (component = getComponent(treeComponentIndex))) return component.getCheckedNodes(fullDataSet);
			return [];
		},

		checkAllNodes: function(treeComponentIndex, autoSelect){
			if(!treeComponentIndex) treeComponentIndex = this.model.states.activeTreeComponentIndex;
			if(autoSelect) this.model.states.autoSelect = true;
			var component;
			if(treeComponentIndex && (component = getComponent(treeComponentIndex))) component.checkAllNodes();
			if(autoSelect) this.model.states.autoSelect = false;
		},

		uncheckAllNodes: function(treeComponentIndex, autoSelect){
			if(!treeComponentIndex) treeComponentIndex = this.model.states.activeTreeComponentIndex;
			if(autoSelect) this.model.states.autoSelect = true;
			var component;
			if(treeComponentIndex && (component = getComponent(treeComponentIndex))) component.uncheckAllNodes();
			if(autoSelect) this.model.states.autoSelect = false;
		},

		checkNodes: function(nodeIndexes, treeComponentIndex, autoSelect){
			if(!treeComponentIndex) treeComponentIndex = this.model.states.activeTreeComponentIndex;
			if(autoSelect) this.model.states.autoSelect = true;
			var component;
			if(treeComponentIndex && (component = getComponent(treeComponentIndex))) component.checkNodes(nodeIndexes);
			if(autoSelect) this.model.states.autoSelect = false;
		},

		uncheckNodes: function(nodeIndexes, treeComponentIndex, autoSelect){
			if(!treeComponentIndex) treeComponentIndex = this.model.states.activeTreeComponentIndex;
			if(autoSelect) this.model.states.autoSelect = true;
			var component;
			if(treeComponentIndex && (component = getComponent(treeComponentIndex))) component.uncheckNodes(nodeIndexes);
			if(autoSelect) this.model.states.autoSelect = false;
		},

		/**
		 * this function is used to select a node identified by the given nodeID and nodeContext and returns if the selection has been successful or not.
		 *
		 * @param   nodeID              mixed - nodeID
		 * @param   nodeContext         string - nodeContext
		 * @param   treeComponentIndex  int - treeComponentIndex - optional (if not given the tree will be estimated according to the nodeIndex)
		 * @param   autoSelect          boolean - should the autoSelectMode be activated or not (default: false)
		 * @returns {boolean} success
		 */
		selectNodeByID: function(nodeID, nodeContext, treeComponentIndex, autoSelect){
			var self = this;
			var nodeSelectionSuccessful = false;
			if(autoSelect) this.model.states.autoSelect = true;
			if(this.nodeExists(nodeID, nodeContext)){
				var nodeIndex = this.getNodeIndex(nodeID, nodeContext);
				var treeComponentIndexData;
				if(treeComponentIndex){
					treeComponentIndexData = {};
					treeComponentIndexData[treeComponentIndex] = {};
				}
				else {
					treeComponentIndexData = this.model.states.trees;
				}

				var component;
				utils.forEach(treeComponentIndexData, function(states, treeComponentIndex){
					if(treeComponentIndex && (component = getComponent(treeComponentIndex)) && component.selectNodeByIndex(nodeIndex)){
						self.model.states.activeTreeComponentIndex = treeComponentIndex;
						self.model.states.trees[self.model.states.activeTreeComponentIndex].selectedNodeIndex = nodeIndex;
						nodeSelectionSuccessful = true;
					}
				});
			}
			if(autoSelect) this.model.states.autoSelect = false;
			return nodeSelectionSuccessful;
		},

		/**
		 * this function is used to select a node identified by the given nodeIndex and returns if the selection has been successful or not.
		 *
		 * @param   nodeIndex           int - nodeIndex
		 * @param   treeComponentIndex  int - treeComponentIndex - optional (if not given the tree will be estimated according to the nodeIndex)
		 * @param   autoSelect          boolean - should the autoSelectMode be activated or not (default: false)
		 * @returns {boolean} success
		 */
		selectNodeByIndex: function(nodeIndex, treeComponentIndex, autoSelect){
			var self = this;
			var nodeSelectionSuccessful = false;
			if(autoSelect) this.model.states.autoSelect = true;
			if(this.nodeExistsByIndex(nodeIndex)){
				var treeComponentIndexData;
				if(treeComponentIndex){
					treeComponentIndexData = {};
					treeComponentIndexData[treeComponentIndex] = {};
				}
				else {
					treeComponentIndexData = this.model.states.trees;
				}

				var component;
				utils.forEach(treeComponentIndexData, function(states, treeComponentIndex){
					if(treeComponentIndex && (component = getComponent(treeComponentIndex)) && component.selectNodeByIndex(nodeIndex)){
						self.model.states.activeTreeComponentIndex = treeComponentIndex;
						self.model.states.trees[self.model.states.activeTreeComponentIndex].selectedNodeIndex = nodeIndex;
						nodeSelectionSuccessful = true;
					}
				});
			}
			if(autoSelect) this.model.states.autoSelect = false;
			return nodeSelectionSuccessful;
		},

		/**
		 * this function is used to deselect the selected node of the actual active tree.
		 * NOTE: this function does not harm if there is no selected node in the actual active tree.
		 */
		deselectActiveNode: function(){
			if(!utils.isEmpty(this.model.states.activeTreeComponentIndex) && !utils.isEmpty(this.model.states.trees[this.model.states.activeTreeComponentIndex].selectedNodeIndex)){
				getComponent(this.model.states.activeTreeComponentIndex).deselectNode(this.model.states.trees[this.model.states.activeTreeComponentIndex].selectedNodeIndex);
			}
		},

		/**
		 * this function is used to deselect a node identified by the given nodeIndex and returns if the selection has been successful or not.
		 *
		 * @param   nodeIndex           int - nodeIndex
		 * @param   treeComponentIndex  int - treeComponentIndex - optional (if not given the tree will be estimated according to the nodeIndex)
		 * @param   autoSelect          boolean - should the autoSelectMode be activated or not (default: false)
		 * @returns {boolean} success
		 */
		deselectNodeByIndex: function(nodeIndex, treeComponentIndex, autoSelect){
			var self = this;
			var nodeSelectionSuccessful = false;
			if(autoSelect) this.model.states.autoSelect = true;
			if(this.nodeExistsByIndex(nodeIndex)){
				var treeComponentIndexData;
				if(treeComponentIndex){
					treeComponentIndexData = {};
					treeComponentIndexData[treeComponentIndex] = {};
				}
				else {
					treeComponentIndexData = this.model.states.trees;
				}

				var component;
				utils.forEach(treeComponentIndexData, function(states, treeComponentIndex){
					if(treeComponentIndex && (component = getComponent(treeComponentIndex)) && component.deselectNode(nodeIndex)){
						self.model.states.trees[self.model.states.activeTreeComponentIndex].selectedNodeIndex = undefined;
						nodeSelectionSuccessful = true;
					}
				});
			}
			if(autoSelect) this.model.states.autoSelect = false;
			return nodeSelectionSuccessful;
		},

		/**
		 * this function returns parent node of the node identified by the wantedNodeIndex param which has no other parents.
		 * NOTE: if the parent cannot be found this function throws an error.
		 * NOTE: this function will work only if the iterative jstree format will be used (parent flag not children flag)
		 *
		 * @param   wantedNodeIndex     int - which node should be returned
		 * @returns {
		 *              entry:      <treeEntry>,
		 *              nodeData:   <nodesEntry>,
		 *              treeIndex:  <indexOfTreeWithin buildMemory.trees[]>
		 *          }
		 */
		getRootParentOfNode: function(wantedNodeIndex){
			if(!this.resourceData || utils.isEmpty(this.resourceData.trees)) return false;

			if(utils.isEmpty(wantedNodeIndex)) throw new Error('cannot find root parent node of empty wantedNodeIndex');

			var wantedEntry;
			var entry;
			do {
				wantedEntry = this.config.treeIndexMapping[wantedNodeIndex];
				if(wantedEntry && wantedEntry.treeIndex != undefined && wantedEntry.nodeTreeIndex != undefined && this.resourceData.trees[wantedEntry.treeIndex] && this.resourceData.trees[wantedEntry.treeIndex].tree){
					entry = this.resourceData.trees[wantedEntry.treeIndex].tree[wantedEntry.nodeTreeIndex];
					if(entry){
						if(utils.isEmpty(entry.parent) || entry.parent === '#'){
							return {
								entry:      entry,
								nodeData:   this.resourceData.trees[wantedEntry.treeIndex].nodes[entry.id],
								treeIndex:  wantedEntry.treeIndex
							};
						}
						wantedNodeIndex = entry.parent;
					}
					else {
						throw new Error('parent index not found in entry');
					}
				}
				else {
					throw new Error('parent Index not found');
				}
			} while(wantedEntry);

			throw new Error('parent Index not found in tree');
		},

		/**
		 * this function is used to call the elementFound-callbackFunction if the filter-callbackFunction returns true.
		 * both of them get exactly one parameter: {
		 *                                           entry:     <treeEntry>
		 *                                           nodeData:  <nodeData>
		 *                                           treeIndex: <treeIndex within this.resourceData.trees>
		 *                                         }
		 * NOTE: this function will work only if the iterative jstree format will be used (parent flag not children flag)
		 *
		 * @param   filter          function - if this function returns true the elementFound callback will be called
		 * @param   elementFound    function - will be called if filter is true
		 */
		getFilteredNodes: function(filter, elementFound){
			if(!utils.isFunction(filter) || !utils.isFunction(elementFound)) return;

			var self = this;
			var tree;
			var entry;
			var nodeData;
			var node;
			utils.forEach(self.config.treeIndexMapping, function(mapping){
				tree        = self.resourceData.trees[mapping.treeIndex];
				entry       = tree.tree[mapping.nodeTreeIndex];
				nodeData    = tree.nodes[entry.id];
				node        = {
					context:    entry.type,
					entry:      entry,
					nodeData:   nodeData,
					treeIndex:  mapping.treeIndex
				};

				if(filter(node)) elementFound(node);
			});
		},

		/**
		 * this function filters the nodes of the actual tree according to the given filterCallback and sets the readyNode (used after refresh)
		 * to the closest node according to the given nodeIndex.
		 *
		 * @param nodeIndex             int - index which identifies the closest node (node right after, node right before or parent node)
		 */
		setClosestNodeAsReady: function(nodeIndex){
			var nodeIndexes = getComponent(this.model.states.activeTreeComponentIndex).getClosestNodes(nodeIndex || this.model.states.trees[this.model.states.activeTreeComponentIndex].selectedNodeIndex);
			if(nodeIndexes.length > 0){
				var position = utils.indexOf(nodeIndexes, nodeIndex);
				var nodeID, nodeContext;
				if(nodeIndexes[position + 1] && (nodeID = this.getNodeID(nodeIndexes[position + 1])) && (nodeContext = this.getNodeContext(nodeIndexes[position + 1]))){
					this.config.readyNodeID = nodeID;
					this.config.readyNodeContext = nodeContext;
				}
				else if(nodeIndexes[position - 1] && nodeIndexes[position - 1] !== '#' && (nodeID = this.getNodeID(nodeIndexes[position - 1])) && (nodeContext = this.getNodeContext(nodeIndexes[position - 1]))){
					this.config.readyNodeID = nodeID;
					this.config.readyNodeContext = nodeContext;
				}
			}
		},

		/**
		 * this function is used to actualize the filterValue within the search plugin of jstree limited by
		 * the given nr of milliseconds in filterDelay param to prevent mass filter refresh.
		 * this has to be done within one js-tree instance indentified by treeComponentIndex. this index
		 * can be left empty. then all available trees will be used for searching.
		 *
		 * @param filterValue           string - what you want to find
		 * @param filterDelay           int - nr of milliseconds delay
		 * @param treeComponentIndex    int - treeComponentIndex to filter
		 */
		search: function(filterValue, filterDelay, treeComponentIndex){
			var treeComponentIndexes = [];
			if(!treeComponentIndex) treeComponentIndexes = Object.keys(this.model.states.trees);
			else                    treeComponentIndexes.push(treeComponentIndex);

			var component;
			utils.forEach(treeComponentIndexes, function(treeComponentIndex){
				if(treeComponentIndex && (component = getComponent(treeComponentIndex))){
					component.search(filterValue, filterDelay);
				}
			});
		},

		/**
		 * this function is the common variant of routeTrees type filter
		 * @param filterParams		object - key value list of filter params
		 */
		setFilterParams: function(filterParams){
			this.model.filterParams = filterParams || {};
		},

		/**
		 * this function returns the minSortValue of the actual active tree or undefined otherwise.
		 *
		 * @returns number | undefined
		 */
		getActiveTreeMinSortValue: function(){
			if(!utils.isEmpty(this.model.states.activeTreeComponentIndex)){
				return getComponent(this.model.states.activeTreeComponentIndex).config.minSortValue;
			}

			return undefined;
		},

		/**
		 * this function returns the maxSortValue of the actual active tree or undefined otherwise.
		 *
		 * @returns number | undefined
		 */
		getActiveTreeMaxSortValue: function(){
			if(!utils.isEmpty(this.model.states.activeTreeComponentIndex)){
				return getComponent(this.model.states.activeTreeComponentIndex).config.maxSortValue;
			}
		},

		/**
		 * this function returns the nodeIndex of the last node within the tree identified by the given treeComponentIndex
		 * and matching the given context if some context has been given.
		 *
		 * @param   context             string - matching context - optional
		 * @param   parentNodeIndex     mixed - parentNodeIndex - optional (undefined || '#', <parentNodeIndex>)
		 * @param   treeComponentIndex  int - treeComponentIndex to search within (default: activeTreeComponentIndex)
		 * @param   matchNode           function - this function gets the nodeEntry as the first and the nodeData as the second argument.
		 *                              if this function returns false the node will be ignored.
		 * @returns int                 nodeIndex of last node matching the given context or -1 in an error case
		 */
		getLastNodeIndex: function(context, parentNodeIndex, matchNode, treeComponentIndex){
			var nodeIndex = -1;
			if(!treeComponentIndex) treeComponentIndex = this.model.states.activeTreeComponentIndex;
			var ignoreMatchNode = !utils.isFunction(matchNode);

			if(context || parentNodeIndex || !ignoreMatchNode){
				var component;
				var treeIndex = (treeComponentIndex && (component = getComponent(treeComponentIndex)) ? component.config.registerSecret : undefined);
				if(treeIndex != undefined && this.resourceData.trees[treeIndex] && this.resourceData.trees[treeIndex].tree) {
					for(var i = this.resourceData.trees[treeIndex].tree.length - 1; i > 0; i--){
						if(
							(!context || this.getNodeContext(this.resourceData.trees[treeIndex].tree[i].id) == context)
							&&
							(!parentNodeIndex || this.resourceData.trees[treeIndex].tree[i].parent == parentNodeIndex)
							&&
							(ignoreMatchNode || matchNode(this.resourceData.trees[treeIndex].tree[i], this.getNodeData(this.resourceData.trees[treeIndex].tree[i].id, treeComponentIndex)))
						){
							nodeIndex = this.resourceData.trees[treeIndex].tree[i].id;
							break;
						}
					}
				}
			}
			else {
				nodeIndex = this.resourceData.trees[treeIndex].tree[this.resourceData.trees[treeIndex].tree.length - 1].id;
			}

			return nodeIndex;
		},

		/**
		 * this function returns the nodeIndex identified by the given parameters.
		 *
		 * @param   parentIndex             mixed - nodeIndex identifying the parent node (undefined or '#' for root level)
		 * @param   position                int - position within parent starting with zero
		 * @param   treeComponentIndex      int - within with tree should be searched - optional (default. activeTreeComponentIndex)
		 * @param   matchNode               function - this function gets the nodeEntry as the first and the nodeData as the second argument.
		 *                                  if this function returns false the node will be ignored.
		 * @returns int                     nodeIndex of found entry or -1 in an error case
		 */
		getPositionIndex: function(parentIndex, position, matchNode, treeComponentIndex){
			var self = this;
			var nodeIndex = -1;
			if(!treeComponentIndex) treeComponentIndex = this.model.states.activeTreeComponentIndex;
			var ignoreMatchNode = !utils.isFunction(matchNode);

			if(parentIndex != undefined && parentIndex !== '#'){
				var parentEntry = self.getNode(parentIndex, treeComponentIndex);
				if(Array.isArray(parentEntry.children)){
					while(parentEntry.children[position] && (ignoreMatchNode || !matchNode(self.getNode(parentEntry.children[position], treeComponentIndex), self.getNodeData(parentEntry.children[position], treeComponentIndex)))){
						position++;
					}

					if(parentEntry.children[position]) nodeIndex = parentEntry.children[position];
				}
			}
			else if(treeComponentIndex) {
				var component;
				var treeIndex = (treeComponentIndex && (component = getComponent(treeComponentIndex)) ? component.config.registerSecret : undefined);
				if(treeIndex != undefined && self.resourceData.trees[treeIndex] && self.resourceData.trees[treeIndex].tree) {
					var pos = 0;
					utils.forEach(self.resourceData.trees[treeIndex].tree, function (entry) {
						if((entry.parent === '#' || entry.parent == undefined) && (ignoreMatchNode || matchNode(entry, self.getNodeData(entry.id, treeComponentIndex)))){
							if(pos == position){
								nodeIndex = entry.id;
								return false;
							}
							else {
								pos++;
							}
						}
					});
				}
			}

			return nodeIndex;
		},

		/**
		 * this function returns the new sort field value according to the given parameters.
		 *
		 * @param   moveEntryContext            string - context of the element which is moving
		 * @param   targetParentNodeIndex       mixed - nodeIndex of targetParentNode || undefined || '#'
		 * @param   targetInParentPosition      int - index position starting with zero (counting elements starting at the identified parent node per level)
		 * @param   targetParentSortValue       int - sortValue of the targetParentNode
		 * @param   matchNodeCallback           function - this function gets the nodeEntry as the first and the nodeData as the second argument.
		 *                                      if this function returns false the corresponding node will be ignored.
		 *                                      NOTE: e.g., with this function the node types which should be taken into account can be limited.
		 *                                      NOTE: if this parameter is undefined all nodes will be taken into account.
		 * @param   treeComponentIndex          int - this is the treeComponentIndex identifying the operating treeComponent.
		 *                                      NOTE: if this parameter is not set the activeTreeComponentIndex will be used instead.
		 * @returns int                         new sort value or -1 in an error case.
		 */
		getNewSortFieldValue: function(moveEntryContext, targetParentNodeIndex, targetInParentPosition, targetParentSortValue, matchNodeCallback, treeComponentIndex){
			// init
			var sort = -1;
			if(!treeComponentIndex) treeComponentIndex = this.model.states.activeTreeComponentIndex;
			var targetNodeIndex = this.getPositionIndex(targetParentNodeIndex, targetInParentPosition, matchNodeCallback, treeComponentIndex);

			// position does not exist
			if(targetNodeIndex < 0){
				targetNodeIndex = this.getLastNodeIndex(moveEntryContext, targetParentNodeIndex, matchNodeCallback, treeComponentIndex);
				// last node could not be identified => empty tree || or no matching node found within parent
				if(targetNodeIndex < 0){
					// parent contains no matching nodes
					if(targetParentSortValue){
						sort = targetParentSortValue + 1;
					}
					// empty tree
					else {
						sort = 1;
					}
				}
				// move node to last position
				else {
					var targetNode = this.getNodeData(targetNodeIndex, treeComponentIndex);
					if(targetNode) sort = targetNode.sort + 1;
				}
			}
			// move node to identified position
			else {
				var targetNode = this.getNodeData(targetNodeIndex, treeComponentIndex);
				if(targetNode) sort = targetNode.sort;
			}

			return sort;
		},

		/**
		 * this function is used to handle a part of the performTreeAction function which can be overwritten.
		 *
		 * @param 	options		{} - all options needed to perform the right action on an jstree event. (see this.performTreeAction() for details)
		 * @return 	Promise || undefined
		 */
		getTreeAction: function(options){
			// perform action
			var performedAction;

			// sanitize options if necessary
			this.sanitizeTreeActionOptions(options);

			// prevent right click actions and actions the sanitizer does not want to be performed.
			if((options.rightClickInCharge && !options.rightClickIsNormalAction) || options.abortAction) return;

			if(!utils.isEmpty(this.actions[options.actionKey])){
				if(options.storeAction){
					if(options.forceOverwriteStoredAction){
						var primaryKey;
						if(options && options.nodeData && options.nodeData._primaryKey != undefined) primaryKey = options.nodeData._primaryKey;
						if(primaryKey == undefined) primaryKey = options.nodeData.id;

						performedAction = this.performAndStoreAction(
							options.actionKey,
							this.prepareAction(options.baseActionKey, primaryKey, {
								nodeData: options.nodeData || undefined,
								...(options.additionalResourceRegister || {})
							}, {
								refreshPersistent:  false,
								postProcessing: 	options.postProcessing
							}),
							true
						);
					} else {
						performedAction = this.performAction(
							this.prepareAction(options.actionKey, undefined, options.additionalResourceRegister, {
								postProcessing: options.postProcessing
							})
						);
					}
				}
				else if(options.clearActionComponent){
					if(!utils.isEmpty(this.actions[options.actionKey].source.load.component)){
						this.actions[options.actionKey].source.load.component.clear();
					}
					else if(!utils.isEmpty(this.actions[options.actionKey].source.load.componentTree)) {
						this.actions[options.actionKey].source.load.componentTree[this.actions[options.actionKey].source.load.componentTree.childLayoutIndex].clear();
					}
				}
			}
			// perform action function if possible
			else if(utils.isFunction(this[options.baseActionOperation])){
				if(options.clearActionComponent){
					if(this.actions[options.actionKey]){
						if(!utils.isEmpty(this.actions[options.actionKey].source.load.component)){
							this.actions[options.actionKey].source.load.component.clear();
						}
						else if(!utils.isEmpty(this.actions[options.actionKey].source.load.componentTree)) {
							this.actions[options.actionKey].source.load.componentTree[this.actions[options.actionKey].source.load.componentTree.childLayoutIndex].clear();
						}
					}
				}
				else {
					this[options.baseActionOperation](options.baseActionKey, options.baseActionContext, undefined, undefined, { options: options });
				}
			}
			// perform new action
			else if(!utils.isEmpty(this.actions[options.baseActionKey])){
				if(options.storeAction){
					var primaryKey;
					if(options && options.nodeData && options.nodeData._primaryKey != undefined) primaryKey = options.nodeData._primaryKey;
					if(primaryKey == undefined) primaryKey = options.nodeData.id;

					performedAction = this.performAndStoreAction(
						options.actionKey,
						this.prepareAction(options.baseActionKey, primaryKey, {
							nodeData: options.nodeData || undefined,
							...(options.additionalResourceRegister || {})
						}, {
							refreshPersistent:  false,
							postProcessing: 	options.postProcessing
						})
					);
				}
				else if(this.actions[options.baseActionKey].type != CONSTANTS.COMPONENT.ACTION.TYPE.SUBMIT_RESOURCE) {
					performedAction = this.performAction(
						this.prepareAction(options.baseActionKey, undefined, options.additionalResourceRegister, {
							postProcessing: options.postProcessing
						})
					);
				}
			}
			else {
				// TODO: CLEANUP
				// console.log('INFO: Action not found on ' + options.eventType + ' @ ' + options.baseActionKey + ' or ' + options.actionKey);
			}

			return performedAction;
		},

		/**
		 * this function may be overwritten to manipulate the treeActionOptions.
		 *
		 * @param 	refOptions		{} - all options needed to perform the right action on an jstree event. (see this.performTreeAction() for details)
		 */
		sanitizeTreeActionOptions: function(refOptions){
			// NOTE: OVERWRITE FOR ACTION MANIPUTLATION
		},

		/**
		 * this function performs all actions according to the jsTree events which have been triggered.
		 *
		 * @param   options                 trigger options of onTreeAction hook
		 * @param   onTreeActionCallback    function - this callback will be called if the treeAction has been performed.
		 *                                  NOTE:   this is not realized as a promise chain to be able to
		 *                                          process a full reperform of the action in case of a 401 re-login process.
		 * @returns Promise                 returns the action promise
		 */
		performTreeAction: function(options, onTreeActionCallback){
			// init
			var storeAction = false;
			var forceOverwriteStoredAction = false;
			var clearActionComponent = false;
			var actionKey;
			var baseActionKey = 'UnknownBaseAction';
			var baseActionOperation, baseActionContext;
			if(options.baseActionKey){
				baseActionKey = options.baseActionKey;
			}
			else {
				var nodeType = 'undefinedNodeType';
				if(options.eventData && options.eventData.node && options.eventData.node.type){
					nodeType = options.eventData.node.type;
				}

				if(options.operation){
					if(this.config.nodeActionMapping){
						if(this.config.nodeActionMapping.defaultBaseActions && this.config.nodeActionMapping.defaultBaseActions[options.operation] && this.config.nodeActionMapping.defaultBaseActions[options.operation][nodeType]){
							baseActionKey = this.config.nodeActionMapping.defaultBaseActions[options.operation][nodeType];
						}
						else {
							var operation 	= options.operation;
							var context		= nodeType;
							if(this.config.nodeActionMapping.defaultContext && this.config.nodeActionMapping.defaultContext[nodeType]){
								context = this.config.nodeActionMapping.defaultContext[nodeType];
							}
							if(this.config.nodeActionMapping.defaultOperation && this.config.nodeActionMapping.defaultOperation[options.operation]){
								operation = this.config.nodeActionMapping.defaultOperation[options.operation];
							}
							baseActionKey = operation + '_' + context;
						}
					}
					else {
						baseActionKey = options.operation + '_' + nodeType;
					}
				}
			}

			if(baseActionKey !== 'UnknownBaseAction'){
				var baseActionParts = baseActionKey.split('_');
				if(baseActionParts.length > 0) baseActionOperation = baseActionParts[0];
				if(baseActionParts.length > 1) baseActionContext = baseActionParts[1];
			}

			// define postProcessing function if necessary
			// NOTE: e.g., if a selectTreeEntry returns a 401 re-login the right actionForm should be shown after successful relogin and the corresponding action reperform process.
			var postProcessing;
			if(utils.isFunction(onTreeActionCallback)){
				postProcessing = function(context){
					context.onTreeActionOptions = options;
					onTreeActionCallback(context);
					return utils.promise.resolve(context);
				};
			}

			// set some states
			switch (options.eventType) {
				case 'select_node.jstree':
					storeAction = true;
					forceOverwriteStoredAction = true;
					actionKey = baseActionKey + '-' + options.treeComponentIndex;
					break;

				case 'deselect_node.jstree':
					clearActionComponent = true;
					actionKey = baseActionKey + '-' + options.treeComponentIndex;
					break;
			}


			var performedAction = this.getTreeAction({
				actionKey: 					actionKey,
				baseActionKey: 				baseActionKey,
				baseActionOperation: 		baseActionOperation,
				baseActionContext: 			baseActionContext,
				postProcessing: 			postProcessing,
				clearActionComponent: 		clearActionComponent,
				storeAction: 				storeAction,
				forceOverwriteStoredAction: forceOverwriteStoredAction,
				nodeData: 					options.nodeData,
				rightClickInCharge: 		options.rightClickInCharge,
				rightClickIsNormalAction: 	options.rightClickIsNormalAction,
				preventDeselect: 			options.preventDeselect,
				preventActionForward: 		options.preventActionForward,
				additionalResourceRegister: {}
			});

			// return fallback or performed action
			if(performedAction != undefined){
				return performedAction;
			}
			if(utils.isFunction(onTreeActionCallback)) onTreeActionCallback({ onTreeActionOptions: options });
			return utils.promise.resolve({ onTreeActionOptions: options });
		},

		/**
		 * prepare tree states before some ready.jstree events wants to use it.
		 *
		 * @param data
		 */
		postBuildSanitize: function(data){
			if(data.action.originalActionKey === 'addTree'){
				// prepare states
				if(utils.isEmpty(this.model.states.trees[data.action.source.load.component.componentIndex])){
					this.model.states.trees[data.action.source.load.component.componentIndex] = {};
				}
			}
		},

		/**
		 * this function is used to add a new tree to the this trees object.
		 *
		 * @param   treeIndex       int - treeIndex - this is used to map the resourceData for the tree within the resourceRegister.
		 * @param   treeType        string - treeType identifier
		 *                          NOTE:   this treeType is the key within the resourceData.tree identifying the treeComponentType
		 *                                  which can overwrite the tree component which should be used for one tree.
		 * @returns Promise - addTree operation done
		 */
		addTree: function(treeIndex, treeType){
			// init
			var nextRegisterSecret = this.model.actualNrOfTrees++;
			treeType = treeType || 'default';

			return this.performAndStoreAction(
				undefined,
				this.prepareAction(
					'addTree',
					undefined,
					{
						tree: {
							treeIndex: treeIndex
						}
					},
					{
						source: {
							load: {
								componentData: {
									component: this.config.treeTypeComponents[treeType],
									config: {
										registerSecret: nextRegisterSecret
									}
								},
								resourceRegisterKey: 'tree'
							}
						}
					}
				)
			);
		},

		/**
		 * this function will be called when the data of an actions has been successfully loaded.
		 * if it returns true the corresponding action will be aborted.
		 *
		 * @param 	actionContext
		 * @return 	boolean - abort?
		 */
		abortAction: function(actionContext){
			if(
				this.model.doubleClickOccurred &&
				this.config.doubleClickAbortActions &&
				actionContext.action &&
				actionContext.action.originalActionKey
			){
				var k;
				for(k in this.config.doubleClickAbortActions){
					if(actionContext.action.originalActionKey.indexOf(this.config.doubleClickAbortActions[k]) === 0){
						this.model.doubleClickOccurred = false;
						return true;
					}
				}
			}

			return false;
		},

		/**
		 * show selection dependent areas
		 */
		showSelectionDependentAreas: function(){
			this.$.removeClass('invisibleSelectionDependentAreas');
		},

		/**
		 * hide selection dependent areas
		 */
		hideSelectionDependentAreas: function(){
			this.$.addClass('invisibleSelectionDependentAreas');
		},

		/**
		 * this function is used to refresh the trees object without killing the node-state or scroll-position if necessary.
		 *
		 * @param restoreTreeState		boolean - default: true - should the tree state be restored.
		 *
		 * @returns {*}
		 */
		refreshTrees: function(restoreTreeState){
			var self = this;
			var component;
			if(restoreTreeState === undefined) restoreTreeState = true;

			// backup state
			if(restoreTreeState){
				utils.forEach(this.model.states.trees, function(states, treeComponentIndex){
					if(treeComponentIndex && (component = getComponent(treeComponentIndex))){
						component.backupState(self.config.treeIndexMapping, self.config.nodeIDMapping);
					}
				});
			}

			// refresh resources
			return this.performAction('refreshResources')
				.then(function(){
					// refresh dom object
					self.refresh(false);

					// restore tree states when they are ready
					if(restoreTreeState){
						self.treesReady(function(){
							utils.forEach(self.model.states.trees, function(states, treeComponentIndex){
								if(treeComponentIndex && (component = getComponent(treeComponentIndex))){
									component.restoreState(self.config.treeIndexMapping, self.config.nodeIDMapping);
								}
							});
						});
					}

					return utils.promise.resolve();
				})
			;
		},

		/**
		 * this function is used to tell the jsTree instances what to do onReady according to the trees config.
		 * e.g., close all nodes located at a higher level than configured to be open.
		 *
		 * @param config
		 */
		treesInitByConfig: function(){
			var self = this;
			var component;
			utils.forEach(self.model.states.trees, function(treeStates, treeComponentIndex){
				if(treeComponentIndex && (component = getComponent(treeComponentIndex))){
					component.treeInitByConfig({
						maxOpenedLevelOnInit: self.config.preventGUIHandlingOfMaxOpenedLevelOnInit ? false : self.config.maxOpenedLevelOnInit
					});
				}
			});
		},

		onScrollLimitCheck: function(deltaTime){
			if(this.config.supportOnScrollLimits){
				if(deltaTime === undefined) 	deltaTime = 50;
				if(this.model.onScrollTimeout) 	clearTimeout(this.model.onScrollTimeout);

				if(deltaTime > 0){
					this.model.onScrollTimeout = setTimeout(function(self){
						self.onScrollLimitCheck(0);
					}, deltaTime, this);
				} else {
					var $scrollContainer;
					var $fullHeightContainer;
					var self = this;
					this.find('base_trees_tree', function(treeComponent){
						if((treeComponent.actualParentComponent || {}).componentIndex !== self.componentIndex) return;
						$scrollContainer = treeComponent.$;
						$fullHeightContainer = $scrollContainer.find('> .tree');
					});

					if(
						$scrollContainer.length > 0 &&
						$fullHeightContainer.length > 0
					){
						var scrollTop = $scrollContainer.scrollTop();
						this.updateScrollTop(scrollTop);

						if(scrollTop <= 20){
							this.onScrollLimitReached(false);
						} else if(($fullHeightContainer.height() - $scrollContainer.height() - scrollTop) <= 20){
							this.onScrollLimitReached(true);
						}
					}
				}
			}
		},

		onScrollLimitReached: function(endReached){

		},

		updateScrollTop: function(scrollTop){
			// OVERWRITE THIS IF WANTED
		}
	},

	hooks: {
		attach: function($element, options){
			// init
			var self = this;
			var performingActions = [];

			if(options.refresh) {
				// add trees which has not been previously found
				utils.forEach(this.resourceData.trees, function (tree, treeIndex) {
					if(!self.registry[treeIndex]){
						performingActions.push(self.addTree(treeIndex, tree.type));
					}
				});
				// remove trees which does not exist any longer
				utils.forEach(this.registry, function (tree, treeIndex) {
					if(!self.resourceData.trees || !self.resourceData.trees[treeIndex]){
						delete self.model.states.trees[tree.tree.componentIndex];
						self.model.actualNrOfTrees--;
						tree.tree.destroy();
					}
				});
			}
			else {
				delete this.model.states.activeTreeComponentIndex;
				this.model.states.trees = {};
				this.model.actualNrOfTrees = 0;

				utils.forEach(this.resourceData.trees, function (tree, treeIndex) {
					performingActions.push(self.addTree(treeIndex, tree.type));
				});
			}

			if(performingActions.length > 0){
				return utils.promise.performAll(self, performingActions).then(function(data){
					if(options.refresh){
						self.treesReady(function(){
							var component;
							utils.forEach(self.model.states.trees, function(treeStates, treeComponentIndex){
								if(treeStates.checkedNodes && treeComponentIndex && (component = getComponent(treeComponentIndex)) && component.hasPlugin('checkbox')) self.checkNodes(treeStates.checkedNodes, treeComponentIndex, true);
							});
						});
					} else {
						self.treesReady(function(){self.treesInitByConfig()});
					}

					if(utils.isFunction(data.component.onAttachDone)) data.component.onAttachDone();
				});
			}
			else if(utils.isFunction(self.onAttachDone)){
				if(options.refresh){
					self.treesReady(function(){
						var component;
						utils.forEach(self.model.states.trees, function(treeStates, treeComponentIndex){
							if(treeStates.checkedNodes && treeComponentIndex && (component = getComponent(treeComponentIndex)) && component.hasPlugin('checkbox')) self.checkNodes(treeStates.checkedNodes, treeComponentIndex, true);
						});
					});
				} else {
					self.treesReady(function(){self.treesInitByConfig()});
				}
				self.onAttachDone(options.refreshResourcesOnly);
			}

			if(options.refresh){
				this.treesReady();
			} else {
				this.treesReady(function(){self.treesInitByConfig()});
			}
		},

		/**
		 * this hook is used by tree.js and will be called each time a js tree event will be fired.
		 * NOTE:    if the default behaviour should be conserved this hook must not be overwritten by inheritance!
		 *          therefor it is possible to overwrite the onTreeAction-Method which will be called directly afterwards.
		 *
		 * @param $element
		 * @param options
		 */
		onTreeAction: function($element, options){
			// init
			var self = this;

			switch(options.eventType){
				case 'ready.jstree':
					// mark tree as ready
					this.treesReady();
					var treeState;
					options.operation = 'ready';

					// select newNode if necessary
					if(this.config.selectNewNodeAfterRefresh && this.config.readyNodeID !== undefined){
						if(this.selectNodeByID(self.config.readyNodeID, self.config.readyNodeContext, undefined, true)){
							delete this.config.readyNodeID;
							return;
						}
					}
					// preselect previously selected node
					else if(this.config.selectActualNodeAfterRefresh && (treeState = this.model.states.trees[options.treeComponentIndex]) && !utils.isEmpty(treeState.selectedNodeIndex)){
						// prevent deselection workaround from deselect init-selection
						var selectedNodeIndex, checkedNodes;
						if((checkedNodes = this.model.states.trees[options.treeComponentIndex].checkedNodes) != undefined && checkedNodes.length > 0){
							this.checkNodes(checkedNodes, options.treeComponentIndex, true);
						}
						else if((selectedNodeIndex = this.model.states.trees[options.treeComponentIndex].selectedNodeIndex)){
							this.model.states.trees[options.treeComponentIndex].selectedNodeIndex = undefined;
							this.selectNodeByIndex(selectedNodeIndex, options.treeComponentIndex, true);
						}
					}

					if(this.model.states.activeTreeComponentIndex == undefined && this.config.defaultTreeOperationsOnFirstTree){
						this.model.states.activeTreeComponentIndex = (this.model.actualNrOfTrees > 0 ? this.registry[Object.keys(this.registry).shift()].tree.componentIndex : undefined);
						if(this.model.states.trees[this.model.states.activeTreeComponentIndex]){
							delete this.model.states.trees[this.model.states.activeTreeComponentIndex].selectedNodeIndex;
						}
					}

					if(this.config.supportOnScrollLimits){
						// default events cannot be used for this, since the tree itself is created by action and the scroll event is a little diva.
						self.find('base_trees_tree', function(treeComponent){
							if((treeComponent.actualParentComponent || {}).componentIndex !== self.componentIndex) return;
							treeComponent.$.on('scroll', function(){
								self.onScrollLimitCheck();
							});
						});
					}
					break;

				case 'changed.jstree':
					options.operation = 'changed';
					this.model.states.trees[options.treeComponentIndex].checkedNodes = this.getCheckedNodes();
					break;

				case 'select_node.jstree':
					options.operation = 'select';
					// other tree has active node
					if(this.model.states.activeTreeComponentIndex !== undefined && (this.model.states.activeTreeComponentIndex != options.treeComponentIndex)) {
						var activeTreeComponent = getComponent(this.model.states.activeTreeComponentIndex)
						if(activeTreeComponent) activeTreeComponent.deselectNode(this.model.states.trees[this.model.states.activeTreeComponentIndex].selectedNodeIndex);
					}
					// deselect already selected node on select (tree-js bug workaround)
					else if(!options.preventDeselect && !options.autoSelect && this.model.states.activeTreeComponentIndex === options.treeComponentIndex && this.model.states.trees[options.treeComponentIndex].selectedNodeIndex == options.eventData.node.id){
						if(!options.rightClickInCharge || options.rightClickIsNormalAction){
							var activeTreeComponent = getComponent(this.model.states.activeTreeComponentIndex)
							if(activeTreeComponent) activeTreeComponent.deselectNode(this.model.states.trees[this.model.states.activeTreeComponentIndex].selectedNodeIndex);
						}
						if(!options.rightClickIsNormalAction) return;
					}

					// prepare node selection
					this.model.states.activeTreeComponentIndex = options.treeComponentIndex;
					this.model.states.trees[options.treeComponentIndex].selectedNodeIndex = options.eventData.node.id;
					options.nodeData = this.getNodeData(options.eventData.node.id);
					break;

				case 'deselect_node.jstree':
					options.operation = 'deselect';
					if(this.config.defaultTreeOperationsOnFirstTree){
						this.model.states.activeTreeComponentIndex = (this.model.actualNrOfTrees > 0 ? this.registry[0].tree.componentIndex : undefined);
					}
					this.model.states.trees[options.treeComponentIndex].selectedNodeIndex = undefined;
					options.nodeData = this.getNodeData(options.eventData.node.id);
					break;

				case 'move_node.jstree':
					options.operation = 'move';
					var moveEntry = options.eventData.node;
					this.config.readyNodeID = this.getNodeID(moveEntry.id);
					this.config.readyNodeContext = this.getNodeContext(moveEntry.id);
					break;

				case 'dnd_start.vakata':
					options.operation = 'dnd_start';
					var nodeIndex = ((options.eventData.data || {}).nodes || [])[0];
					if(nodeIndex) this.setSpecialNodeData('dnd', { nodeIndex });
					break;

				case 'dnd_stop.vakata':
					options.operation = 'dnd_stop';
					this.setSpecialNodeData('dnd');
					break;
			}

			// perform default tree actions
			return this.performTreeAction(options, function(context){
				// call tree actions of final implementation if necessary
				if(utils.isFunction(self.onTreeAction)) self.onTreeAction(context);
			});
		}
	}
};